// Обвязка пульта (задача D4): кэш запросов и роутер. Тосты, тема и всё общее для экранов — в каркасе (shell/app-shell.tsx, D5).
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

export interface AppProvidersProps {
  readonly queryClient: QueryClient;
  readonly router: ReturnType<typeof createBrowserRouter>;
}

export function AppProviders({ queryClient, router }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
